// src/api.js
import axios from 'axios';

// API URL from environment variable
const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
});

export const BASE_URL = API_URL;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      if (!error.response.data) {
        error.response.data = {};
      }
      
      const detail = error.response.data.detail || "You don't have permission to access this resource.";
      error.response.data.detail = detail;

      if (detail.includes("disabled/inactive") || detail.includes("account has been deactivated")) {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login?error=deactivated';
        }
      }
    } else if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
